import React, { FC } from 'react';

import { RequiredRule } from 'devextreme-react/form';

import { AppCol, AppFieldBox, AppRow } from 'components/appComponents';
import { Button, Validator } from 'devextreme-react';
import { NumberBox } from 'devextreme-react';

type PriceProps = {
  value: number;
  readOnly: boolean;
  onChange: (value: number) => void;
  clearButton: () => void;
};

const Price: FC<PriceProps> = ({ value, readOnly, onChange, clearButton }) => {
  return (
    <AppFieldBox label="Цена за куб" labelTop>
      <AppRow>
        <AppCol col={11}>
          <NumberBox
            stylingMode="underlined"
            readOnly={readOnly}
            placeholder=""
            mode="text"
            value={value}
            onChange={(e) => {
              //@ts-ignore
              onChange(+e.event!.target?.value);
            }}
          >
            <Validator>
              <RequiredRule message="Заполните поле Цена за куб" />
            </Validator>
          </NumberBox>
        </AppCol>
        <AppCol col={1}>
          <Button icon="revert" onClick={clearButton} />
        </AppCol>
      </AppRow>
    </AppFieldBox>
  );
};

export default Price;
